import { useState } from "react";
import { History, Loader2 } from "lucide-react";
import { api } from "../../lib/api";
import { formatDateTime } from "../../lib/format";

const LABELS = { cambio_id: "Cambio de ID", vinculado: "Vinculado", bandeja: "Por clasificar → cliente", reacomodo: "Archivo reacomodado",
  propuesta_ia: "Propuesta de IA resuelta", cliente_no_real: "Cliente no real eliminado" };

const line = (c) => {
  if (c.tipo === "cliente_no_real") return `${c.cliente} (${c.from}): ${Object.entries(c.asignados).map(([b, n]) => `${n} a ${b}`).join(", ") || "0 a clientes"}; ${c.por_clasificar} a Por clasificar`;
  if (c.tipo === "propuesta_ia") return `${c.propuesta} → ${c.to} (${c.archivos} archivos)`;
  return `${c.cliente || c.archivo}: ${c.from} → ${c.to}`;
};

export const ChangeList = ({ changes, testId = "import-changes" }) => (
  <ul className="max-h-56 space-y-0.5 overflow-y-auto text-xs text-[#3b475c]" data-testid={testId}>
    {changes.map((c, i) => (
      <li key={i} data-testid={`${testId}-item-${i}`}><b>{LABELS[c.tipo] || c.tipo}</b> · {line(c)}</li>
    ))}
  </ul>
);

export const ImportHistory = () => {
  const [batches, setBatches] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = async () => {
    setBusy(true);
    try {
      setBatches((await api.get("/import/history")).data);
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="space-y-2" data-testid="import-history">
      <button type="button" onClick={load} className="inline-flex items-center gap-1.5 text-xs font-semibold text-[#0f5ef7] hover:underline" data-testid="import-history-button">
        {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <History className="h-3.5 w-3.5" />} Historial de importaciones
      </button>
      {batches && !batches.length && <p className="text-xs text-[#5b667a]">Todavía no hay importaciones con cambios registrados.</p>}
      {batches?.map((b, i) => (
        <details key={b.id} open={i === 0} className="rounded-[12px] border border-[#e8edf5] px-3 py-2" data-testid={`import-batch-${i}`}>
          <summary className="cursor-pointer text-xs font-bold text-[#182235]">{formatDateTime(b.at)} · {b.source} · {b.by} · {b.changes.length} cambios</summary>
          <ChangeList changes={b.changes} testId={`import-batch-${i}-changes`} />
        </details>
      ))}
    </div>
  );
};
